module.exports = __webpack_public_path__ + "officialStatic/img/first.ac108fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/xplan/first.png
// module id = An45
// module chunks = 0